import { CdnService } from '@/common/services/cdn/cdn.service';
import { TermsUseResponse } from '@/core/domain/terms-use/models/terms-use-response.model';
import { TermsUseRepository } from '@/core/domain/terms-use/repositories/rental-policy.respository';
import { TranslationsGetLanguageUseCase } from '@/core/domain/translation/usecases/translations-get-language.usecase';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TermsUseImplRepository extends TermsUseRepository {
    constructor(
        private readonly http: HttpClient,
        private readonly getLanguageUseCase: TranslationsGetLanguageUseCase,
    ) {
        super();
    }

    override getTermsUse(): Observable<TermsUseResponse> {
        return this.http.get<TermsUseResponse>(
            CdnService.url(
                'terms-use-json/' +
                    this.getLanguageUseCase.execute().language +
                    '.json',
            ),
        );
    }
}
